import { BaseMultiText } from '../../../translation';
import { currentBuilderState } from '../builder.state';
import { MAX_SELECTABLE_METRICS } from '../const/max-selectable-metrics.const';

import { updateRouterQueryParams } from './update-router-query-params.function';
import { updateSectionLabels } from './update-section-labels.function';

export function removeMetric(m: BaseMultiText): void {
    const state = currentBuilderState();

    state.viewParams.metricLookup[m.id] = false;

    const index: number = state.viewParams.metrics.indexOf(m);
    state.viewParams.metrics.splice(index, 1);

    state.cannotSelectMetrics =
        state.viewParams.metrics?.length >= MAX_SELECTABLE_METRICS;

    updateSectionLabels();
    updateRouterQueryParams();
}
